import React, { useContext, useEffect, useRef, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import Avatar from '../Avatar';
import styles from './styles.module.css';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import blankGroup from '../../../../assets/imgs/blank-group-picture.png';
import Button from '../Button';
import AppIcons from '../../icons';
import CookieFunction from '../../functions/cookieFunction';
import Api from '../../api';
const GroupMembers = ({ informLeftUser, updateUser }) => {
  const {
    privateUsers,
    content,
    activeUser,
    direction,
    setUpdateSocket,
    userChannelId,
    setActiveUser,
  } = useContext(AdminContext);
  const [openBox, setopenBox] = useState(false);
  const [levelManage, setLevelManage] = useState(0);
  const [users, setUsers] = useState([]);
  const ref = useRef();
  let channelId = CookieFunction('get', 'userAuthOchatt');
  const clickFunction = (id) => {
    if (id == openBox) {
      setopenBox();
    } else {
      setopenBox(id);
    }
  };
  useEffect(() => {
    setLevelManage(
      activeUser?.users?.[
        activeUser?.users?.findIndex((x) => x?.channelUser?.uuid == channelId)
      ]?.levelManage
    );
    setUsers(
      activeUser?.users

        .filter((x) => x.typeId != 2)
        .filter((x) => x.statusId != 0)
    );
  }, [activeUser]);
  // console.log(
  //   'levelmanage',
  //   levelManage,
  //   activeUser?.users
  //     ?.slice(1)
  //     ?.findIndex((x) => x?.channelUser?.uuid == channelId),
  //   channelId,
  //   content?.groupMemberMore
  // );
  const checkIfClickedOutside = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (openBox && ref.current && !ref.current.contains(e.target)) {
      setopenBox(false);
      console.log('firstdepen');
    }
  };
  const clickItem = (item, user) => {
    if (item?.id == 1) {
      adminFunction(user);
    }
    if (item?.id == 2) {
      deleteFunction(user);
    }

    setopenBox(false);
  };
  const adminFunction = (x) => {
    Api.adminMemberUser(x?.channelUserId, {
      params: { roomId: x.roomId, levelManage: x?.levelManage == 2 ? 0 : 2 },
    })
      .then((res) => {
        // props?.informLeftUser(res?.data?.response?.messageId);
        let newarray = [...users];
        let index = newarray?.findIndex(
          (m) => m?.channelUserId == x?.channelUserId
        );

        newarray[index].levelManage = x?.levelManage == 2 ? 0 : 2;
        setActiveUser({ ...activeUser, users: newarray });
        console.log('levelManage', newarray[index].levelManage);
        informLeftUser(res?.data?.response?.messageId);
        // updateUser({
        //   uuid: userChannelId,
        //   typeId: activeUser?.typeId,
        //   // roomId: activeUser?.id,
        // });
        // setUpdateSocket('user');

        setopenBox(false);
      })
      .catch((err) => {
        console.log('levelManage', err);
      });
  };
  const deleteFunction = (x) => {
    Api.deleteMemberUser(x?.channelUserId, {
      params: { roomId: x.roomId, levelManage: x?.levelManage },
    })
      .then((res) => {
        let newarray = [...users];
        newarray = newarray?.filter(
          (m) => m?.channelUserId != x?.channelUserId
        );

        setActiveUser({ ...activeUser, users: newarray });
        informLeftUser(res?.data?.response?.messageId);
        // updateUser({
        //   uuid: userChannelId,
        //   typeId: activeUser?.typeId,
        //   // roomId: activeUser?.id,
        // });
        // setUpdateSocket('user');

        setopenBox(false);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [openBox]);
  return (
    <div className={`${styles.containerWrapper}`}>
      <div className={styles.container}>
        {users?.slice(1)?.map((user, index) => (
          <div
            className={`flex flex-row justify-between items-center h-auto w-auto my-[5px] ${`userBoxStyle`} relative `}
            key={index}
          >
            <div className={`flex flex-row justify-start items-start`}>
              <Avatar
                width={24}
                height={24}
                containerclassName={`cursorDefault`}
                className={`cursorDefault`}
                src={
                  user?.channelUser?.image?.name
                    ? user?.channelUser?.image?.name
                    : user.typeId == 2
                    ? blankGroup
                    : blanckUser
                }
                local={!user?.channelUser?.image?.name}
              />
              <p className={`text-right ${styles.userText} cursorDefault`}>
                {user?.channelUser?.channelName
                  ? user?.channelUser?.channelName
                  : user?.channelUser?.username}
              </p>
            </div>
            {user?.levelManage != 1 && levelManage != 0 ? (
              <div>
                <AppIcons.MoreIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    clickFunction(user?.channelUser?.uuid);
                  }}
                  fill={'#000'}
                />
                {openBox == user?.channelUser?.uuid && (
                  <div
                    className={`${styles.settingBox} ${
                      direction == 'ltr' && styles.settingBoxRight
                    } themeBox `}
                    ref={ref}
                  >
                    {content?.groupMemberMore?.map((item, index) => (
                      <div
                        className={`flex flex-row justify-between items-center w-full h-auto`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          clickItem(item, user);
                        }}
                        key={index}
                      >
                        {item?.id == 1 && (
                          <>
                            <p className={`preserveStyle cursor-pointer`}>
                              {user?.levelManage == 2
                                ? item?.notChosen
                                : item?.chosen}
                            </p>
                            <div
                              className={`flex flex-row justify-center items-center`}
                            >
                              {item?.icon}
                            </div>
                          </>
                        )}
                        {item?.id == 2 && user?.levelManage != 1 && (
                          <>
                            <p className={`preserveStyle cursor-pointer`}>
                              {user?.levelManage == 2
                                ? item?.notChosen
                                : item?.chosen}
                            </p>
                            <div
                              className={`flex flex-row justify-center items-center`}
                            >
                              {item?.icon}
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <>
                {user?.levelManage == 1 && (
                  // <p>{content.groupMember?.owner}</p>
                  <AppIcons.GroupOwner />
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
export default GroupMembers;
